import { analyticsService } from '../../service/analytics-service'
import { coreService } from '../../service/core-service'

/**
 * Binds analytics to the signed-in account. The SDKs themselves are brought up at app boot
 * (`index.tsx`), for guests and members alike; this runs under `CoreLayout`, after `AuthInitiate`
 * has confirmed there is a session, and is the one place `identify` happens.
 */
export class AnalyticsInitiate {
  public get Name(): string {
    return 'Analytics'
  }

  protected _destroyFn(): Promise<void> {
    return Promise.resolve(undefined)
  }

  protected async _initFn(): Promise<void> {
    analyticsService.init()
    const me = await coreService.getMe()
    analyticsService.identify(me)
  }
}
